import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/login.vue';
import pay from '@/components/pay.vue';
import userInfo from '@/components/userInfo.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    { path: '/login', component: login },
    { path: '/pay', component: pay, meta: { requiresAuth: true } },
    { path: '/user', component: userInfo, meta: { requiresAuth: true } },
    { path: '/', component: userInfo, meta: { requiresAuth: true } }
    // 其他路由
  ]
});

// // 路由守卫
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token');
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!token) {
//       next('/login');
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

export default router;